<script setup>
import { computed } from 'vue'
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxTextBox } from 'devextreme-vue/text-box'
import { DxDateBox } from 'devextreme-vue/date-box'
import { DxCheckBox } from 'devextreme-vue/check-box'
import { DxNumberBox } from 'devextreme-vue/number-box'
import { booleanDisplayExpr } from '@/composables/label'
import { useLookupModelMap } from '@/composables/registry/import-export-lookup'
import CityDropDownBox from '@/components/shared/CityDropDownBox.vue'
import CountryDropDownBox from '@/components/shared/CountryDropDownBox.vue'
import CustomerDropDownBox from '@/components/shared/CustomerDropDownBox.vue'
import VehicleDropDownBox from '@/components/shared/VehicleDropDownBox.vue'

const props = defineProps({
  field: { type: Object, required: true },
  cellInfo: { type: Object, required: true },
  disabled: { type: Boolean, default: false },
})

const { getEditorOptionsForField } = useLookupModelMap()
const options = computed(() => getEditorOptionsForField(props.field))
const editors = {
  lookup: DxSelectBox,
  date: DxDateBox,
  boolean: DxCheckBox,
  number: DxNumberBox,
  city: CityDropDownBox,
  country: CountryDropDownBox,
  customer: CustomerDropDownBox,
  vehicle: VehicleDropDownBox,
}
const editor = computed(() => editors[options.value.editor || options.value.type] || DxTextBox)
const editorProps = computed(() => {
  const value = props.disabled ? null : props.cellInfo.value
  if (options.value.editor) return { value, showClearButton: true, ...(options.value.editor === 'city' ? { structuredOnly: true } : {}) }
  switch (options.value.type) {
    case 'lookup': {
      const { dataSource, valueExpr, displayExpr } = options.value
      return {
        value, dataSource, valueExpr, displayExpr,
        showClearButton: true,
        searchEnabled: true,
        searchExpr: typeof displayExpr === 'string' ? displayExpr : ['code', 'name'],
      }
    }
    case 'date':
      return { value, type: 'date' }
    case 'boolean':
      return { value: value === true || value === 'true', text: booleanDisplayExpr(value), elementAttr: { style: 'padding-left: 0.5rem' } }
    case 'number':
      return { value }
    default:
      return { value: value == null ? value : String(value) }
  }
})

const onValueChanged = (event) => {
  if (props.disabled) return
  const value = options.value.editor ? event.value?.id ?? event.value : event.value
  if (value === props.cellInfo.value) return
  if (options.value.type === 'lookup' && !options.value.editor) props.cellInfo.setValue(value, event.component.option('text'))
  else props.cellInfo.setValue(value)
}
</script>

<template>
  <component
    :is="editor"
    v-bind="editorProps"
    :disabled="props.disabled"
    @value-changed="onValueChanged"
  />
</template>
